import api, { API_BASE } from './api';
import { FileEntity } from '../types';

export const filesService = {
  list: async (params?: {
    projekt_id?: number;
    audit_id?: number;
    schwachstelle_id?: number;
    kunde_id?: number;
    angebot_id?: number;
  }): Promise<FileEntity[]> => {
    const response = await api.get('/files/', { params });
    return response.data;
  },

  get: async (id: number): Promise<FileEntity> => {
    const response = await api.get(`/files/${id}`);
    return response.data;
  },

  upload: async (
    file: File,
    typ?: string,
    projekt_id?: number,
    audit_id?: number,
    schwachstelle_id?: number,
    kunde_id?: number,
    angebot_id?: number,
  ): Promise<FileEntity> => {
    const formData = new FormData();
    formData.append('file', file);
    if (typ) formData.append('typ', typ);
    if (projekt_id) formData.append('projekt_id', projekt_id.toString());
    if (audit_id) formData.append('audit_id', audit_id.toString());
    if (schwachstelle_id) formData.append('schwachstelle_id', schwachstelle_id.toString());
    if (kunde_id) formData.append('kunde_id', kunde_id.toString());
    if (angebot_id) formData.append('angebot_id', angebot_id.toString());

    const response = await api.post('/files/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  download: (id: number) => {
    window.open(`${API_BASE}/files/${id}/download`, '_blank');
  },

  getPreviewUrl: (id: number): string => {
    return `${API_BASE}/files/${id}/preview`;
  },

  getFileContent: async (id: number): Promise<string> => {
    const response = await api.get(`/files/${id}/content`, {
      responseType: 'text',
    });
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/files/${id}`);
  },

  /** Erzeugt aus einem Original eine bearbeitete Bildversion (Original bleibt erhalten). */
  createBearbeitung: async (originalId: number, rendered: Blob, annotationen: string): Promise<FileEntity> => {
    const formData = new FormData();
    formData.append('file', rendered, 'bearbeitet.png');
    formData.append('annotationen', annotationen);
    const response = await api.post(`/files/${originalId}/bearbeitungen`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  /** Ueberschreibt Bild und Annotationen einer bearbeiteten Version (gleiche Datei-ID). */
  updateBearbeitung: async (fileId: number, rendered: Blob, annotationen: string): Promise<FileEntity> => {
    const formData = new FormData();
    formData.append('file', rendered, 'bearbeitet.png');
    formData.append('annotationen', annotationen);
    const response = await api.put(`/files/${fileId}/bearbeitungen`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};
